export const translations = {
  ar: {
    pageTitle: " الإجازات",
    pageSubtitle: "إدارة طلبات الإجازات واستعراض الأرصدة بسهولة",

    leaveTypes: {
      annual: "إجازة سنوية",
      sick: "إجازة مرضية",
      maternity: "إجازة رعاية طفل",
      emergency: "إجازة طارئة",
      workFromHome: "عمل من المنزل",
      partialDay: "طلب يوم جزئي",
    },

    leaveDescriptions: {
      annual: "أيام إجازة مدفوعة للراحة والاستجمام",
      sick: "إجازة طبية لحالات صحية",
      maternity: "إجازة للآباء الجدد",
      emergency: "إجازة غير مخططة للطوارئ",
      workFromHome: "طلبات العمل من المنزل",
      partialDay: "طلب لنصف يوم عمل - الإجازة تُخصم من الإجازة السنوية",
    },

    stats: {
      totalAvailable: "إجمالي المتاح",
      daysUsed: "الأيام المستخدمة",
      daysRemaining: "الأيام المتبقية",
      averageDuration: "متوسط المدة",
      annualAllocation: "التخصيص السنوي",
      daysPerYear: "يوم في السنة",
      utilized: "مُستخدم",
      thisYear: "هذا العام",
      availableNow: "متاح الآن",
      untilDec: "حتى 31 ديسمبر",
      perRequest: "لكل طلب",
      days: "أيام",
    },

    balance: {
      title: "نظرة عامة على رصيد الإجازات",
      used: "مُستخدم",
      total: "الإجمالي",
      left: "المتبقي",
      percentUsed: "مُستخدم",
      expires: "تنتهي:",
    },

    tabs: {
      overview: "نظرة عامة",
      history: "سجل الإجازات",
      team: "تقويم الفريق",
      holidays: "العطلات الرسمية",
    },

    request: {
      title: "طلب إجازة",
      submitRequest: "تقديم الطلب",
      cancel: "إلغاء",
      submitting: "جاري التقديم...",
      leaveType: "نوع الإجازة",
      selectType: "اختر نوع الإجازة",
      daysAvailable: "يوم متاح",
      startDate: "تاريخ البداية",
      endDate: "تاريخ النهاية",
      reason: "السبب",
      reasonPlaceholder: "يرجى تقديم سبب طلب الإجازة...",
      handover: "تعليمات تسليم العمل",
      handoverPlaceholder: "صف كيف سيتم التعامل مع عملك أثناء غيابك...",
      date: "التاريخ",
      halfDayType: "نوع نصف اليوم",
      firstHalf: "النصف الأول (صباحي)",
      secondHalf: "النصف الثاني (عصري)",
      selectHalfDayType: "اختر نوع نصف اليوم",
    },

    sections: {
      leaveInfo: "معلومات الإجازة",
      dateRange: "نطاق التاريخ",
      requestDetails: "تفاصيل الطلب",
      dateInfo: "معلومات التاريخ",
      reviewInfo: "معلومات المراجعة",
    },

    status: {
      approved: "موافق عليها",
      pending: "قيد الانتظار",
      rejected: "مرفوضة",
      cancelled: "ملغاة",
    },

    history: {
      title: "سجل الإجازات",
      noHistory: "لا يوجد سجل إجازات",
      recentRequests: "الطلبات الأخيرة",
      noRecentRequests: "لا توجد طلبات إجازة حديثة.",
      viewDetails: "عرض التفاصيل",
    },

    details: {
      title: "تفاصيل طلب الإجازة",
      leaveType: "نوع الإجازة",
      status: "الحالة",
      startDate: "تاريخ البداية",
      endDate: "تاريخ النهاية",
      duration: "المدة",
      reason: "السبب",
      handover: "تعليمات التسليم",
      approvedBy: "تمت الموافقة بواسطة",
      notAssigned: "غير معين",
      pendingReview: "قيد المراجعة",
      close: "إغلاق",
    },

    team: {
      title: "تقويم إجازات الفريق",
      loading: "جاري تحميل تقويم الفريق...",
      noLeaves: "لا توجد إجازات للفريق في هذه الفترة",
      selectMonth: "اختر الشهر",
      selectYear: "اختر السنة",
    },

    holidays: {
      title: "العطلات الرسمية القادمة",
      global: "عطلة عالمية",
      national: "عطلة وطنية",
      daysUntil: "أيام ",
      today: "اليوم",
    },

    quickActions: {
      title: "إجراءات سريعة",
      requestLeave: "طلب إجازة",
      submitNew: "تقديم طلب جديد",
      viewCalendar: "عرض التقويم",
      checkSchedule: "التحقق من الجدول",
      exportReport: "تصدير التقرير",
      downloadHistory: "تحميل السجل",
      analytics: "التحليلات",
      usagePatterns: "أنماط الاستخدام",
    },

    months: {
      1: "يناير",
      2: "فبراير",
      3: "مارس",
      4: "أبريل",
      5: "مايو",
      6: "يونيو",
      7: "يوليو",
      8: "أغسطس",
      9: "سبتمبر",
      10: "أكتوبر",
      11: "نوفمبر",
      12: "ديسمبر",
    },

    messages: {
      success: "تم تقديم طلب الإجازة بنجاح.",
      error: "فشل تقديم طلب الإجازة",
      loading: "جاري تحميل بيانات الإجازات...",
      missingId: "معرف الموظف مفقود.",
      selectDates: "يرجى اختيار تاريخ البداية والنهاية.",
      invalidDates: "تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية.",
      selectHalfDayType: "يرجى اختيار نوع نصف اليوم.",
    },

    units: {
      day: "يوم",
      days: "أيام",
    },
  },
  en: {
    pageTitle: "Leave Management",
    pageSubtitle: "Manage leave requests and view balances easily",

    leaveTypes: {
      annual: "Annual Leave",
      sick: "Sick Leave",
      maternity: "Maternity/Paternity Leave",
      emergency: "Emergency Leave",
      workFromHome: "Work From Home",
      partialDay: "Partial Day Request",
    },

    leaveDescriptions: {
      annual: "Paid days off for rest and recreation",
      sick: "Medical leave for health conditions",
      maternity: "Leave for new parents",
      emergency: "Unplanned leave for emergencies",
      workFromHome: "Remote work requests",
      partialDay: "Half-day leave request - 0.5 days deducted from Annual Leave",
    },

    stats: {
      totalAvailable: "Total Available",
      daysUsed: "Days Used",
      daysRemaining: "Days Remaining",
      averageDuration: "Average Duration",
      annualAllocation: "Annual Allocation",
      daysPerYear: "days per year",
      utilized: "Utilized",
      thisYear: "This Year",
      availableNow: "Available Now",
      untilDec: "until Dec 31",
      perRequest: "per request",
      days: "days",
    },

    balance: {
      title: "Leave Balance Overview",
      used: "Used",
      total: "Total",
      left: "Left",
      percentUsed: "Used",
      expires: "Expires:",
    },

    tabs: {
      overview: "Overview",
      history: "Leave History",
      team: "Team Calendar",
      holidays: "Public Holidays",
    },

    request: {
      title: "Request Leave",
      submitRequest: "Submit Request",
      cancel: "Cancel",
      submitting: "Submitting...",
      leaveType: "Leave Type",
      selectType: "Select Leave Type",
      daysAvailable: "days available",
      startDate: "Start Date",
      endDate: "End Date",
      reason: "Reason",
      reasonPlaceholder: "Please provide a reason for your leave request...",
      handover: "Work Handover Instructions",
      handoverPlaceholder:
        "Describe how your work will be handled during your absence...",
      date: "Date",
      halfDayType: "Half-Day Type",
      firstHalf: "First Half (Morning)",
      secondHalf: "Second Half (Afternoon)",
      selectHalfDayType: "Select half-day type",
    },

    sections: {
      leaveInfo: "Leave Information",
      dateRange: "Date Range",
      requestDetails: "Request Details",
      dateInfo: "Date Information",
      reviewInfo: "Review Information",
    },

    status: {
      approved: "Approved",
      pending: "Pending",
      rejected: "Rejected",
      cancelled: "Cancelled",
    },

    history: {
      title: "Leave History",
      noHistory: "No leave history",
      recentRequests: "Recent Requests",
      noRecentRequests: "No recent leave requests.",
      viewDetails: "View Details",
    },

    details: {
      title: "Leave Request Details",
      leaveType: "Leave Type",
      status: "Status",
      startDate: "Start Date",
      endDate: "End Date",
      duration: "Duration",
      reason: "Reason",
      handover: "Handover Instructions",
      approvedBy: "Approved By",
      notAssigned: "Not Assigned",
      pendingReview: "Pending Review",
      close: "Close",
    },

    team: {
      title: "Team Leave Calendar",
      loading: "Loading team calendar...",
      noLeaves: "No team leaves in this period",
      selectMonth: "Select Month",
      selectYear: "Select Year",
    },

    holidays: {
      title: "Upcoming Public Holidays",
      global: "Global Holiday",
      national: "National Holiday",
      daysUntil: "days until",
      today: "Today",
    },

    quickActions: {
      title: "Quick Actions",
      requestLeave: "Request Leave",
      submitNew: "Submit new request",
      viewCalendar: "View Calendar",
      checkSchedule: "Check schedule",
      exportReport: "Export Report",
      downloadHistory: "Download history",
      analytics: "Analytics",
      usagePatterns: "Usage patterns",
    },

    months: {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "July",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December",
    },

    messages: {
      success: "Leave request submitted successfully.",
      error: "Failed to submit leave request",
      loading: "Loading leave data...",
      missingId: "Employee ID is missing.",
      selectDates: "Please select start and end dates.",
      invalidDates: "Start date cannot be after end date.",
      selectHalfDayType: "Please select a half-day type.",
    },

    units: {
      day: "day",
      days: "days",
    },
  },
};

export default translations;